import React, { useState } from "react";
import { connect } from "react-redux";

import * as Web3Action from "./web3/constants";

import Button from '../components/Button';

import tkgGbsLogoHoriz from '../navigation/tkggbs-logo-horiz.svg';

import '../css/login.css';

const LoadingContainer = ({
  dispatch,
  web3,
  accounts,
  initialized,
  children
}) => {
  const [ data, setData ] = useState({ password: "" });
  const [ removing, setRemoving ] = useState(false);
  const [ removed, setRemoved ] = useState(false);

  const suffix = "20220202091200000";

  const handleSubmit = e => {
    e.preventDefault();

    try {
      const password = data.password;
      const encryptedAccountJson = JSON.stringify(web3.instance.eth.accounts.wallet.encrypt(password));
  
      const hashedSuffix = web3.instance.utils.keccak256(suffix).replace(/^0x/, '');
      const accountPathname = "tkggbs-" + hashedSuffix;
      const pkFilename = localStorage.getItem(accountPathname) 
  
      const stringInJson = JSON.parse(localStorage.getItem(pkFilename));
      const pk = web3.instance.eth.accounts.decrypt(stringInJson, password);
      web3.instance.eth.accounts.wallet.add(pk.privateKey);
      dispatch(notifyCompleteWeb3Initialize());
    } catch {
      setRemoving(true);
    }
  };

  const handleChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const handleSubmitBack = e => {
    setRemoving(false);
  };

  const handleSubmitCancel = e => {
    dispatch(notifyCompleteWeb3Initialize());
  };

  const handleSubmitRemove = e => {
    const hashedSuffix = web3.instance.utils.keccak256(suffix).replace(/^0x/, '');
    const accountPathname = "tkggbs-" + hashedSuffix;
    const pkFilename = localStorage.getItem(accountPathname) 
  
    localStorage.removeItem(pkFilename)
    localStorage.removeItem(accountPathname)

    setRemoved(true);
  };

  if (initialized) {
    if (web3.status === "failed") {
      return (
        <main className="w-100 h-100 bg-navy">
          <div className="pure-g">
            <div className="pure-u-1-1">
              <div className='mv3 mh3 charcoal'>Failed to initialize Web3.</div>
            </div>
          </div>
        </main>
      );
    }

    if (web3.status === "initialized" && Object.keys(accounts).length === 0) {
      return (
        <main className="w-100 h-100 bg-navy">
          <div className="pure-g">
            <div className="pure-u-1-1">
              <div className='pa3 white'>You don't have valid any Ethereum accounts!</div>
              <div>{web3.pkFilename}</div>
            </div>
          </div>
        </main>
      );
    }

    if (web3.status === "initialized") {
      return children;
    }
  }

  if (web3.status === "decrypting" && !removing)
    return (
      <div className='w-100 h-100 bg-navy flex justify-center items-center'>
        <div className='flex flex-column justify-center items-center'>
          <img className='navbar-logo-horiz ma3 center' style={{ height: 84 }} src={tkgGbsLogoHoriz} alt='' />
          <div className='modal bg-navy'>
            <div className='flex flex-column'>
              <div className='mt3 mh3 f5 white'>Input the password for your private key.</div>
              <form className='flex justify-center items-center ma3' onSubmit={handleSubmit}>
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  onChange={handleChange}
                  className='focus-outline mb1'
                  style={{padding: '1px', borderColor: '#ffffff', width: '100%', maxWidth: "400px", MozAppearance: "none", WebkitAppearance: "none" }}
                />
              </form>
              <Button className='mb4 mh3' onClick={handleSubmit}>Next</Button>
            </div>
          </div>
        </div>
      </div>
    );
  else if (removing)
    return (
      <div className='w-100 h-100 bg-navy flex justify-center items-center'>
        <div className='flex flex-column justify-center items-center'>
          <img className='navbar-logo-horiz ma3 center' style={{ height: 84 }} src={tkgGbsLogoHoriz} alt='' />
          <div className='flex flex-column' style={{ width: "480px" }}>
            { !removed
              ? <div>
                  <div className='mv4 mh3 f5 white'>The password you input is wrong!</div>
                  <div className='mb3 mh3 white'>Try again?</div>
                  <Button className='mb3 mh3' style={{ width: "100%" }} onClick={handleSubmitBack}>Back</Button>
                  <div className='mb3 mh3 white'>Or you can stop logging in.</div>
                  <Button className='mb3 mh3' style={{ width: "100%" }} onClick={handleSubmitCancel}>Cancel</Button>
                  <div className='mh3 white'>Or you can remove your private key.</div>
                  <Button className='mt3 mb4 mh3' style={{ width: "100%", backgroundColor: "#eb999d" }} onClick={handleSubmitRemove}>Remove</Button>
                </div>
              : <div>
                  <div className='mh3 f5 white'>Your private key has been removed!</div>
                  <div className='mb4 mh3 f5 white'>Please refresh the page to create new private key.</div>
                </div> }
          </div>
        </div>
      </div>
    );

  return (
    <div className='flex'>
      <div className="atom-spinner">
        <div className="spinner-inner">
          <div className="spinner-line"></div>
          <div className="spinner-line"></div>
          <div className="spinner-line"></div>
          <div className="spinner-circle">
            &#9679;
          </div>
        </div>
      </div>
      <div className='flex items-center justify-center mv2 mh2 charcoal blinking'>Now loading the Web page...</div>
    </div>
  );
};

const notifyCompleteWeb3Initialize = () => {
  return {
    type: Web3Action.WEB3_DECRYPTED
  }
}

const mapStateToProps = state => {
  return {
    web3: state.web3,
    accounts: state.accounts,
    initialized: state.drizzleStatus.initialized,
  };
};

export default connect(mapStateToProps)(LoadingContainer);
